import { TypeOrNull } from '@network/models/common.model'
import { IBaseGetParams } from '@network/models/global.model'
import { IUser } from '@network/models/user.model'

export const BONUSES_ENABLED = true

export interface IBonusCategory {
  id: number
  name: string
}

export enum BONUS_STATUS {
  IN_REVIEW,
  PROCESSED,
}

export enum BONUS_CATEGORY {
  DISCRETIONAL,
  PRODUCTION,
  ADDITIONAL_PAY_OWNED,
}

export const BONUS_CATEGORY_STRING = {
  [BONUS_CATEGORY.ADDITIONAL_PAY_OWNED]: 'Additional pay owned',
  [BONUS_CATEGORY.PRODUCTION]: 'Production',
  [BONUS_CATEGORY.DISCRETIONAL]: 'Discretional',
}

export interface IBonusIncludeParams {
  /**
   * Info for include is missing
   */
  include?: string[]
}

export interface IBonus {
  id: number
  timesheet_id: number
  application_id: number
  gig_day_id: number
  invoice_value: number
  total_invoice_value: number
  commission: number
  category: number
  memo: string
  status: BONUS_STATUS
  created_by_id: number
  edited_by_id: number
  created_at: string
  created_by: IUser
  bonus_category?: TypeOrNull<IBonusCategory>
}

export interface IGetBonusesParamsBase extends IBaseGetParams {
  timesheet_id?: number
  application_id?: number
  gig_day_id?: number
  category?: number
  status?: BONUS_STATUS
  business_id?: number
  user_id?: number
}

export type IGetBonusesParams = IGetBonusesParamsBase & IBonusIncludeParams

export interface IPostBonusParamsBase {
  application_id: number
  gig_day_id?: number
  timesheet_id?: number
  invoice_value: number
  memo?: string
  category: number
}

export type IPostBonusParams = IPostBonusParamsBase & IBonusIncludeParams

export interface IPutBonusParamsBase {
  application_id?: number
  gig_day_id?: number
  timesheet_id?: number
  invoice_value?: number
  memo?: string
  category?: number
}

export type IPutBonusParams = IPutBonusParamsBase & IBonusIncludeParams

export interface IDeleteBonusParams {
  id: number
  gig_id: number
  application_id: number
  timesheet_id: number
}
